import { render, staticRenderFns } from "./timeAsin.vue?vue&type=template&id=aba17f72&scoped=true"
import script from "./timeAsin.vue?vue&type=script&lang=js"
export * from "./timeAsin.vue?vue&type=script&lang=js"
import style0 from "./timeAsin.vue?vue&type=style&index=0&id=aba17f72&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aba17f72",
  null
  
)

export default component.exports